<template>
    <v-row style="padding: 0px; margin: 0px; height: 40px;">
      <v-col cols='1' class="justify-center d-flex" style="padding: 0px; margin: 0px; border-left: 1px solid lightgrey;" >
        <v-checkbox v-model='selected' :disabled='is_select_disabled' color='primary' @change='toggleSelected($event)' style="padding: 10px; margin: 0px;"/>
      </v-col>
      <v-col cols='2' style="padding: 5px; cursor: pointer;" @click='viewStagingProject()'>
        <div class='name wo-name' :class='getConflictClass'>
            <div style="font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"> {{staging_project.project_data.name}} </div>
            <div>
              <div class='address wo-detail white-space: nowrap; overflow: hidden; text-overflow: ellipsis;' :class='getConflictClass'>
                {{ staging_project.project_data.site_address }}
              </div>
            </div>
            <div class='icons'>
              <v-icon
                small
                v-if='staging_project.project_data.is_quickpay'
                color="primary"
              >
                mdi-timer-outline
              </v-icon>
              <v-icon
                small
                v-if='staging_project.project_data.snail_mail_only'
                color="primary"
              >
                mdi-snail
              </v-icon>
            </div>
          </div>
      </v-col>
      <v-col style="padding: 0px; margin: 0px; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey;" class="justify-center d-flex my-0 py-0">
        <v-checkbox disabled color='primary' v-model='is_stage_one' style="padding: 10px; margin: 0px;"/>
      </v-col>
      <v-col style="padding: 0px; margin: 0px; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey;" class="justify-center d-flex my-0 py-0">
        <v-checkbox disabled color='primary' v-model='is_stage_two' style="padding: 10px; margin: 0px;"/>
      </v-col>
      <v-col style="padding: 0px; margin: 0px; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey;" class="justify-center d-flex my-0 py-0">
        <v-checkbox disabled color='primary' v-model='is_stage_three' style="padding: 10px; margin: 0px;"/>
      </v-col>
      <v-col style="padding: 0px; margin: 0px; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey;" class="justify-center d-flex my-0 py-0">
        <v-checkbox disabled color='primary' v-model='is_stage_four' style="padding: 10px; margin: 0px;"/>
      </v-col>
      <v-col v-if="staging_project.type === 'B' || staging_project.type === 'U'" style="padding: 0px; margin: 0px; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey;" class="justify-center d-flex my-0 py-0">
        <v-checkbox disabled color='primary' v-model='is_stage_five' style="padding: 10px; margin: 0px;"/>
      </v-col>
      <v-col style="padding: 0px; margin: 0px; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey;" class="justify-center d-flex my-0 py-0">
        <v-checkbox disabled color='primary' v-model='is_cancelled' style="padding: 10px; margin: 0px;"/>
      </v-col>
    </v-row>
</template>

<script>
export default {
  name: 'staging-project-row',
  props: {
    staging_project: {
      required: true
    }
  },
  data: () => ({
    hover: false,
    status: false,
    selected: false
  }),
  computed: {
    is_stage_one(){
      if(this.staging_project.stage === 1 && this.staging_project.resolution !== 'D'){
        return true;
      }
      return false;
    },
    is_stage_two(){
      if(this.staging_project.stage === 2 && this.staging_project.resolution !== 'D'){
        return true;
      }
      return false;
    },
    is_stage_three(){
      if(this.staging_project.stage === 3 && this.staging_project.resolution !== 'D'){
        return true;
      }
      return false;
    },
    is_stage_four(){
      if(this.staging_project.stage === 4 && this.staging_project.resolution !== 'D'){
        return true;
      }
      return false;
    },
    is_stage_five(){
      if(this.staging_project.stage === 5 && this.staging_project.resolution !== 'D'){
        return true;
      }
      return false;
    },
    is_cancelled(){
      if(this.staging_project.resolution === 'D'){
          return true;
      }
      return false;
    },
    is_select_disabled(){
        return this.staging_project.resolution !== 'I' || this.staging_project.has_serious_conflicts || this.staging_project.on_hold;
    },
    hoverStatus(){
      return this.hover ? "grey lighten-4" : "";
    },
    getConflictClass(){
      if(this.staging_project.resolved === true){
        if(this.staging_project.resolution === 'D'){
          return 'grey--text text--lighten-1';
        }
        return 'blue--text text--darken-2';
      }
      else if(this.staging_project.on_hold){
        return 'grey--text text--lighten-1';
      }
      else if(this.staging_project.has_serious_conflicts){
        return 'red--text text--darken-4';
      }
      else if(this.staging_project.has_conflicts){
        return 'orange--text text--darken-2';
      }
      else{
        return 'green--text';
      }
    }
  },
  methods: {
    viewStagingProject () {
      this.$emit('viewStagingProject', this.staging_project)
    },
    toggleSelected(val){
      this.$emit('select',this.staging_project.id, val);
    },
    selectRow(){
      if(this.staging_project.resolution === 'I'){
        this.selected = true;
      }
    },
    deselectRow(){
      this.selected = false;
    }
  }
}
</script>

<style scoped>

.wo-tile {
  display: grid;
  grid-template-columns: 36px 300px 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 19px 13px;
  cursor: pointer;
}

.bottom-row {
    grid-column: 2;
    grid-row: 2;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
    cursor: pointer;
}

.top-row {
    grid-column: 2;
    grid-row: 1;
    display: flex;
    overflow: hidden;
    cursor: pointer;
}

.icons {
    display: flex;
    align-items: center;
    margin-right: 4px;
}

.wo-type {
  margin-bottom: 1px;
}

.icon {
  margin-left: 1px;
}

.city {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
    min-width: 25px;
    margin-right: auto;
    margin-left: 5px;
    flex-shrink: 100000;
}

.address {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.wo-detail {
  font-size: 11px;
  color: grey;
}
</style>
